import React from 'react';
import SizeAwareContainer from 'Widgets/ui/SizeAwareContainer';
import HeatMap from './HeatMap';
const HeatMapContainer = (props) => (React.createElement(SizeAwareContainer, null,
    React.createElement(HeatMap, { ...props })));
export default HeatMapContainer;
